module.exports = __webpack_public_path__ + "media/index/chicago-tribune-161b3725.svg";